query PlatformsList(
  $page: Int = 0
  $rowsPerPage: Int = 10
  $filter: PlatformsFilterInput
) {
  platforms(page: $page, rowsPerPage: $rowsPerPage, filter: $filter) {
    nodes {
      id
      title
      slug
      description
      status
      published
      host
      slugHost
      slugUrl
      url
      logo {
        id
        url
      }
      createdAt
    }
    count
  }
}
